function StatCard({ title, value, delta, tone }) {
  return (
    <article className="stat-card">
      <p>{title}</p>
      <h3>{value}</h3>
      <span className={`delta-pill ${tone === 'negative' ? 'delta-negative' : 'delta-positive'}`}>
        {delta}
      </span>
    </article>
  );
}

export default StatCard;